import React from 'react';

interface WireGauzeProps {
  position?: [number, number, number];
  rotation?: [number, number, number];
  scale?: number;
}

export function WireGauze({ position = [0, 0, 0], rotation = [0, 0, 0], scale = 1 }: WireGauzeProps) {
  const size = 1.4;
  const thickness = 0.02;

  return (
    <group position={position} rotation={rotation} scale={scale}>
      {/* Outer Rim */}
      <mesh position={[0, 0, 0]}>
        <boxGeometry args={[size, thickness, size]} />
        <meshStandardMaterial color="#888888" wireframe={true} metalness={0.8} />
      </mesh>
      
      {/* Ceramic Center */}
      <mesh position={[0, thickness/2 + 0.001, 0]} rotation={[-Math.PI / 2, 0, 0]}>
        <circleGeometry args={[0.5, 32]} />
        <meshStandardMaterial color="#ffffff" roughness={0.9} />
      </mesh>
    </group>
  );
}
